module.exports = __webpack_public_path__ + "static/img/preview-01.31c80b2e.webp";